import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { TableCell } from '@mui/material';
import { WarningRounded } from '@mui/icons-material';
import ProjectDots from '#component/project/dashboard/project-dots';
import HighlightWord from '#component/general/highlight-word';
import DevicesCountListButton from '#component/general/devices-count-list-button';
import UsersCountListButton from '#component/general/users-count-list-button';
import EditButton from '#component/project/dashboard/icon-button/edit';
import LogsButton from '#component/project/dashboard/icon-button/show-log';
import { getHighlightedSearchResult } from '#component/general/highlight-word/helper';
import { TitleBodyCell, TitleContainer, ProjectTitleText, DescriptionBodyCell } from '#component/project/dashboard/styles';
import { getProjectDateRange, isProjectExpired } from '#helper';

export const ProjectTitleCell = ({ data: project }) => {
  const filter = useSelector(s => s.listFilter, shallowEqual) ?? {};
  const highlightedSearchResult = getHighlightedSearchResult(filter);

  return (
    <TitleBodyCell
      align="left"
      style={{
        whiteSpace: 'nowrap',
        width: 'auto',
        height: 57,
        paddingLeft: 15
      }}
    >
      <TitleContainer>
        <ProjectDots project={project} />
        {highlightedSearchResult ? <HighlightWord
          textToHighlight={project.title}
          searchWord={highlightedSearchResult}
        /> : <ProjectTitleText>{project.title}</ProjectTitleText>}
      </TitleContainer>
    </TitleBodyCell>
  );
};

export const ProjectDescriptionCell = ({ data: project }) => (
  <DescriptionBodyCell align="left">
    {project.description}
  </DescriptionBodyCell>
);

export const ProjectDevicesCell = ({ data: project }) => (
  <TableCell align="left">
    <div>
      <DevicesCountListButton devicesCount={project.devices} project={project} />
    </div>
  </TableCell>
);

export const ProjectUsersCell = ({ data: project }) => (
  <TableCell align="left">
    <div>
      <UsersCountListButton project={project} />
    </div>
  </TableCell>
);

export const ProjectDateCell = ({ data: project, account }) => (
  <TableCell align="left" style={{ whiteSpace: 'nowrap' }}>
    {isProjectExpired(project) && (
      <WarningRounded
        style={{
          color: '#FACE31',
          verticalAlign: 'bottom',
          marginRight: 5
        }}
      />
    )}
    {getProjectDateRange(project, account?.measurementSystem)}
  </TableCell>
);

export const ProjectLogsCell = ({ data: project }) => (
  <TableCell>
    <LogsButton project={project} />
  </TableCell>
);

export const ProjectEditCell = ({ data: project }) => (
  <TableCell>
    <EditButton project={project} />
  </TableCell>
);
